import React from "react";

import styles from "./Section3.module.scss";

export const Section3 = function () {
  return (
    <section id="benefits" className={`${styles.section3Wrapper} cc--component-container`}>
      <div className={styles.section3Container}>
        <h3>You&rsquo;ll Walk Away With:</h3>
        <div className={styles.section3Content}>
          <div className={styles.firstCol}>
            <span>1</span>
          </div>
          <div className={styles.secondCol}>
            <p>
              The ability to draft, strategize and develop a cyber risk mitigation strategy, including the appropriate
              legal and compliance steps that need to be taken when responding to cyberattacks and reporting
              cyberattacks to law enforcement.
            </p>
          </div>
          <div className={styles.firstCol}>
            <span>2</span>
          </div>
          <div className={styles.secondCol}>
            <p>
              An in-depth understanding of the different types of cyberattacks, the business systems that are most at
              risk, and the importance of an organization-wide approach to cybersecurity.
            </p>
          </div>
          <div className={styles.firstCol}>
            <span>3</span>
          </div>
          <div className={styles.secondCol}>
            <p>
              A premier certificate from Harvard University’s Office of the Vice Provost for Advances in Learning, in
              association with HarvardX, as validation of your newfound cybersecurity knowledge and skills, as well as
              access to a global network of likeminded cybersecurity professionals.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};
